<template>
  <v-menu
    v-if="errors?.length"
    :close-on-content-click="false"
    offset-y
    max-width="25rem"
    max-height="30rem"
  >
    <template #activator="{ on: menuOn, attrs: menuAttrs }">
      <v-tooltip
        right
        v-bind="defaultVTooltipProps"
      >
        <template #activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <v-btn
            v-bind="{ ...tooltipAttrs, ...menuAttrs }"
            v-on="{ ...tooltipOn, ...menuOn }"
            depressed
            rounded
            x-small
            color="warning"
            aria-label="Show error"
          >
            <v-icon small>mdi-alert-circle-outline</v-icon>
          </v-btn>
        </template>
        <span>Show error</span>
      </v-tooltip>
    </template>

    <v-card class="pa-2 error-card">
      <!-- <v-card-title>Errors</v-card-title> -->
      <v-card-text>
        <b-table-lite
          :fields="[
            { key: 'name', label: 'Model', class: 'font-weight-bolder' },
            { key: 'error', label: 'Error', class: 'text-break' },
          ]"
          :items="errors"
          borderless
          small
        />
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { defaultVTooltipProps } from '@/utils/defaultProps'
import { formatModelErrorsForDisplay } from '@/components/combined-predict/components/CombinedPredictTable/utils/formatModelErrorsForDisplay'

export default {
  data() {
    return {
      defaultVTooltipProps,
    }
  },
  computed: {
    errors() {
      const row = this.params?.data
      const hasErrors = this?.params?.value
      if (!hasErrors) return []

      return Object.entries(formatModelErrorsForDisplay(row?.errorsByModelId) ?? {}).map(([name, error]) => ({
        name,
        error,
      }))
    },
  },
}
</script>
